module.exports = __webpack_public_path__ + "img/notifications.1c8ee54.svg";